var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "filters__select-boxes-row",
      class: { "filters__select-boxes-row--active": _vm.isActive },
      on: { click: _vm.handleClick }
    },
    [
      _c("span", { staticClass: "filters__select-boxes-row__label" }, [
        _vm._v(_vm._s(_vm.label))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }